export default __webpack_public_path__ + "static/media/step_007.edf5d853.jpeg";